// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1TUWA","description":"PatientConsentPreview_description__35Bqt"};